const Sample = ({ title, interpret, description, song }) => {
  return (
    <div className="container">
      <center>
        <div style={{ height: "110px" }}>
          <h5>
            {title} - {interpret}
          </h5>
          <div>
            <p>"{description}"</p>
          </div>
        </div>
        <audio controls>
          <source src={song} />
        </audio>
        <div style={{ height: "15px" }}/>
      </center>
    </div>
  );
};

export default Sample;
